
import {
    faEdit,
    faPlus,
    faSearch,
    faTrash,
    faExclamation
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useEffect, useState } from "react";

import { toast, ToastContainer } from "react-toastify";

import {
    getCategorias,
    guardarCategoria,
    actualizarCategoria,
    eliminarCategoria
} from "../../../services/categoriaservice";

import "./Categoria.css";

export default function Categoria() {

    const [modalOpen, setModalOpen] = useState(false);

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [categorias, setCategorias] = useState([]);

    const [busqueda, setBusqueda] = useState("");

    const [categoria, setCategoria] = useState({
        idcategoria: 0,
        categoria: '',
        descripcion: '',
        tipo: 2
    });

    const cargarCategorias = async () => {

        try {

            const data = await getCategorias();

            if (!data) {

                toast.error("No hay categorías");

                return;
            }

            setCategorias(data);

        } catch (error) {

            console.error(error);

            toast.error("Error cargando categorías");
        }
    };

    const categoriasFiltradas = categorias.filter((item) =>
        item.categoria?.toLowerCase().includes(busqueda.toLowerCase())
    );

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!categoria.categoria) {

            toast.error("Ingrese categoría");

            return;
        }

        try {

            let result;

            const payload = {
                idcategoria: categoria.idcategoria,
                categoria: categoria.categoria,
                descripcion: categoria.descripcion,
                tipo: categoria.tipo
            };

            if (categoria.idcategoria === 0) {

                result = await guardarCategoria(payload);

            } else {

                result = await actualizarCategoria(payload);
            }

            if (result.status === "success") {

                toast.success(
                    categoria.idcategoria === 0
                        ? "Categoría registrada"
                        : "Categoría actualizada"
                );

                setModalOpen(false);

                setCategoria({
                    idcategoria: 0,
                    categoria: '',
                    descripcion: '',
                    tipo: 2
                });

                cargarCategorias();

            } else {

                toast.error("Error operación");
            }

        } catch (error) {

            console.error(error);

            toast.error("Error servidor");
        }
    };

    const handleEdit = (item) => {

        setCategoria({
            idcategoria: item.idcategoria,
            categoria: item.categoria,
            descripcion: item.descripcion ?? '',
            tipo: item.tipo ?? 2
        });

        setModalOpen(true);
    };

    const borrarCategoria = async () => {

        try {

            const result = await eliminarCategoria({
                idcategoria: categoria.idcategoria
            });

            if (result.status === "success") {

                toast.success("Categoría eliminada");

                setDeleteModalOpen(false);

                setCategoria({
                    idcategoria: 0,
                    categoria: '',
                    descripcion: '',
                    tipo: 2
                });

                cargarCategorias();

            } else {

                toast.error("Error eliminar");
            }

        } catch (error) {

            console.error(error);

            toast.error("Error servidor");
        }
    };

    useEffect(() => {

        cargarCategorias();

    }, []);

    return (

        <div className="main-content">

            <ToastContainer />

            {/* HEADER */}
            <div className='nuevo-container'>

                <div className="search-wrapper">

                    <FontAwesomeIcon
                        icon={faSearch}
                        className="search-icon"
                    />

                    <input
                        type="text"
                        placeholder="Buscar categoría..."
                        className="search-input"
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />

                </div>

                <button
                    className='nuevo'
                    onClick={() => {
                        setCategoria({
                            idcategoria: 0,
                            categoria: '',
                            descripcion: '',
                            tipo: 2
                        });

                        setModalOpen(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    Nueva Categoría
                </button>

            </div>

            {/* TABLE */}
            <div className="table-container">

                <table className="table">

                    <thead>

                        <tr>
                            <th>ID</th>
                            <th>Categoría</th>
                            <th>Descripción</th>
                            <th>Acciones</th>
                        </tr>

                    </thead>

                    <tbody>

                        {categoriasFiltradas.length > 0 ? (

                            categoriasFiltradas.map((item) => (

                                <tr key={item.idcategoria}>

                                    <td>{item.idcategoria}</td>

                                    <td className="nombre-resaltado">
                                        {item.categoria}
                                    </td>

                                    <td>{item.descripcion}</td>

                                    <td style={{ textAlign: "center" }}>

                                        <button
                                            className='editar'
                                            onClick={() => handleEdit(item)}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        <button
                                            className='eliminar'
                                            onClick={() => {
                                                setCategoria(item);
                                                setDeleteModalOpen(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>

                                    </td>

                                </tr>
                            ))

                        ) : (

                            <tr>
                                <td
                                    colSpan="4"
                                    style={{
                                        textAlign: "center",
                                        padding: "20px"
                                    }}
                                >
                                    No hay categorías
                                </td>
                            </tr>

                        )}

                    </tbody>

                </table>

            </div>

            {/* MODAL */}
            {modalOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setModalOpen(false)}
                >

                    <div
                        className="modalWindow"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="modalHeader">

                            <h2>Categoría</h2>

                        </div>

                        <div className="modalBody">

                            <input
                                className="input-modal"
                                placeholder="Nombre categoría"
                                value={categoria.categoria}
                                onChange={(e) =>
                                    setCategoria({
                                        ...categoria,
                                        categoria: e.target.value
                                    })
                                }
                            />

                            <textarea
                                className="input-modal textarea-modal"
                                placeholder="Descripción"
                                value={categoria.descripcion}
                                onChange={(e) =>
                                    setCategoria({
                                        ...categoria,
                                        descripcion: e.target.value
                                    })
                                }
                            />

                        </div>

                        <div className="modalFooter">

                            <button
                                className="modalBtn btnCancelar"
                                onClick={() => setModalOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="modalBtn btnGuardar"
                                onClick={handleSubmit}
                            >
                                Guardar
                            </button>

                        </div>

                    </div>

                </div>
            )}

            {/* DELETE */}
            {deleteModalOpen && (

                <div
                    className="modalOverlay"
                    onClick={() => setDeleteModalOpen(false)}
                >

                    <div
                        className="modalWindow deleteStyle"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <div className="deleteHeader">

                            <button
                                onClick={() => setDeleteModalOpen(false)}
                                className="deleteCloseX"
                            >
                                ×
                            </button>

                        </div>

                        <div className="deleteIconContainer">

                            <div className="deleteIconCircle">

                                <FontAwesomeIcon
                                    icon={faExclamation}
                                />

                            </div>

                        </div>

                        <div className="deleteBodyContent">

                            <h3 className="deleteTitle">
                                ¿Eliminar categoría?
                            </h3>

                            <p className="deleteText">
                                La categoría{" "}
                                <b>{categoria?.categoria}</b>{" "}
                                será eliminada permanentemente.
                            </p>

                            <div className="deleteActions">

                                <button
                                    className="btnCancelGhost"
                                    onClick={() =>
                                        setDeleteModalOpen(false)
                                    }
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btnConfirmFilled"
                                    onClick={borrarCategoria}
                                >
                                    Confirmar
                                </button>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </div>
    );
}

